import { render, staticRenderFns } from "./MutliUpload.vue?vue&type=template&id=0d6be473&scoped=true&"
import script from "./MutliUpload.vue?vue&type=script&lang=js&"
export * from "./MutliUpload.vue?vue&type=script&lang=js&"
import style0 from "./MutliUpload.vue?vue&type=style&index=0&id=0d6be473&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6be473",
  null
  
)

export default component.exports